import React from 'react'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { Box, Paragraph } from '@alto-avios/alto-ui'

import { type ProductSlug } from '~/schemas/browserUrl'

import { getPublicAssetSrc } from '~/utils/assets'

import styles from './ProductPartnershipLabel.module.scss'

type Props = {
  productSlug?: ProductSlug
}

type PartnershipLogo = 'expedia' | 'avis-budget' | 'viator'

const PARTNERSHIP_LABELS: Record<ProductSlug, PartnershipLogo | null> = {
  hotels: 'expedia',
  cars: 'avis-budget',
  experiences: 'viator',
  flights: null,
}

const PARTNERSHIP_LOGO_SIZE: Record<PartnershipLogo, { height: number; width: number }> = {
  expedia: { height: 32, width: 96 },
  'avis-budget': { height: 32, width: 150 },
  viator: { height: 32, width: 96 },
}

const ProductPartnershipLabel = ({ productSlug }: Props) => {
  const t = useTranslations('pages.search')
  const partnership = productSlug ? PARTNERSHIP_LABELS[productSlug] : null
  if (!partnership) {
    return null
  }

  const src = getPublicAssetSrc(`/assets/search-vendor-logos/${partnership}-logo.svg`)
  const logoSize = PARTNERSHIP_LOGO_SIZE[partnership]
  const productPartnershipLabel =
    productSlug === 'hotels'
      ? t('product_partnership_label_hotels')
      : t('product_partnership_label')
  return (
    <Box gap="3xs" className={styles.container}>
      <Paragraph size="sm">{productPartnershipLabel}</Paragraph>
      <Box
        height={`${logoSize.height}px`}
        width={`${logoSize.width}px`}
        maxWidth={`${logoSize.width}px`}
        position="relative"
        className={partnership === 'viator' ? styles.viatorLogoWrapper : undefined}
      >
        <Image
          height={logoSize.height}
          width={logoSize.width}
          src={src}
          alt={`${partnership} partnership logo`}
          objectPosition="middle left"
          layout="responsive"
        />
      </Box>
    </Box>
  )
}

export default ProductPartnershipLabel
